<template>
  <div class="has-text-white">
        <dropper :index="index" :level="2"></dropper>
        <div  v-if="$parent.editMode"  class="delete is-pulled-right" @click="remove"></div>
        <div class="top20">
          <faqitem ref="fItem"  v-for="(item, i) in params.faqs" :key="i" :item="item" :index="i"></faqitem>
        </div>
        <button v-show="$parent.editMode" @click="newItem" class="has-text-white top20 left30 button is-small is-coolGreen has-text-black">New FAQ item</button>
        <br> <br>
  </div>
</template>

<script>

import dropper from './sectionDropper.vue'
import faqitem from '../../components/FAQitem'


export default {
    props: {params: Object, index: Number},
    components: {dropper, faqitem},
    data: function(){
        return {
            
        }
    },

    mounted: function(){
     /*  if(this.$parent.editMode){
        this.$refs.fItem.forEach(e => {
          e.open = true
        })
      } else {
        this.$refs.fItem.forEach(e => {
          e.open = false
        })
      } */
    },

    methods: {

      remove: function(){
          this.$parent.removeSection(this.index)
      },

      newItem: function(){
        this.params.faqs.push({q:'Question', a:'Answer'})
      },

    /*   saveIt: function(){
        var self = this
        setTimeout(function(){
          self.$parent.source[self.index].params.faqs = self.params.faqs.slice()
        }, 5)
        
      }, */

      removeItem: function(i){
        this.params.faqs.splice(i, 1)
      }
    }

 
}

</script>